import ProductContainer from './containers/ProductContainer';

export { default as ProductsDisplay } from './components/ProductsDisplay';
export default ProductContainer;
